import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { observer } from 'mobx-react';
import S from '../../../stores';
import { ComponentJSSClasses } from './styles';
import { BasicFacilities } from './BasicFacilities';
import { FacilitiesList } from './FacilitiesList';
import { ArrowIcon } from '../Icons/ArrowIcon';
import { OpenerBlock } from '../OpenerBlock';
import { Collapse } from 'react-collapse';
import { getFormattedYoutubeLink } from '../../../utils/format';

export interface HotelInfoProps {

}

interface StyledHotelInfoProps extends HotelInfoProps, JSSClassesProps<ComponentJSSClasses> { }

@observer
export class HotelInfo extends React.Component<StyledHotelInfoProps, {}> {

    render() {
        const { classes } = this.props;

        const basicFacilitiesGoups = S.hotelDetails.basicFacilitiesGoups;

        return (
            <div className={classes.container}>
                <div className={classes.title}>
                    Об отеле {S.hotelDetails.hotelName}
                </div>
                {this.renderVideo()}
                {basicFacilitiesGoups.length > 0 && (
                    <BasicFacilities facilities={basicFacilitiesGoups} />
                )}
                {this.renderMobileFacilitiesList()}

                {this.renderCollapseBlock()}
            </div>
        );
    }

    renderMobileFacilitiesList(): JSX.Element | null {
        const { classes } = this.props;

        return (
            <div className={classes.mobileFacilitiesList}>
                <div
                    className={classes.openButton}
                    onClick={() => S.ui.setIsHotelFacilitiesOpen(true)}
                >
                    <div className={classes.openButtonTitle}>
                        Все услуги отеля
                    </div>
                    <div className={classes.arrow}>
                        <ArrowIcon
                            width={15}
                            height={15}
                            fill={'#0087BE'}
                        />
                    </div>
                </div>

                <OpenerBlock
                    isOpen={S.ui.isHotelFacilitiesOpen}
                    title="Услуги отеля"
                    fullWidht={true}
                    onClose={() => S.ui.setIsHotelFacilitiesOpen(false)}
                >
                    <FacilitiesList facilitiesGroups={S.hotelDetails.facilityGroups} />
                </OpenerBlock>
            </div>
        );
    }

    renderCollapseBlock(): JSX.Element {
        const { classes } = this.props;

        const title = S.ui.isHotelDescriptionOpen ? 'Свернуть' : 'Подробнее об отеле';
        const allFacilitiesGroups = S.hotelDetails.facilityGroups;

        if (!allFacilitiesGroups.length && !S.hotelDetails.hotelDescription) {

            return (
                <div className={classes.emptyText}>
                    <p>Пока нет информации об услугах. Скоро исправим.</p>
                </div>
            );
        }

        const collapseClasses = `${classes.collapser} ${S.ui.isHotelDescriptionOpen && classes.openedCollapser}
                ${!S.hotelDetails.hotelDescription && classes.descriptionEmptyCollapser}`;

        return (
            <>
                {!!S.hotelDetails.hotelDescription && (S.hotelDetails.hotelDescription?.length ?? 0) > 1 &&
                    (<React.Fragment>
                        <Collapse
                            className={collapseClasses}
                            isOpened={S.ui.isHotelDescriptionOpen}
                            springConfig={{ stiffness: 120, damping: 25, precision: 5 }}
                            title={title}
                            onClick={() => S.ui.setHotelDescriptionOpen(!S.ui.isHotelDescriptionOpen)}
                        >
                            <div className={classes.collapserContent}>
                                <div
                                    className={classes.description}
                                    dangerouslySetInnerHTML={{
                                        __html: S.hotelDetails.hotelDescription || ''
                                    }}
                                />
                            </div>
                        </Collapse>
                        {!S.ui.isHotelDescriptionOpen && (
                            <div
                                className={`${classes.showMore} ${!S.hotelDetails.hotelDescription && classes.mobileHidden}`}
                                onClick={() => S.ui.setHotelDescriptionOpen(true)}
                            >
                                <span className={classes.showMoreText}>Подробнее</span>
                                <span className={classes.arrowDown}>
                                    <ArrowIcon
                                        width={15}
                                        height={15}
                                        fill={'#0087BE'}
                                    />
                                </span>
                            </div>
                        )}
                    </React.Fragment>)}
                <div className={classes.collapserContent}>
                    <div className={classes.facilities}>
                        <FacilitiesList facilitiesGroups={S.hotelDetails.facilityGroups} />
                    </div>
                </div>

            </>
        );
    }

    renderVideo(): JSX.Element | null {
        const { classes } = this.props;
        if (!S.hotelDetails.videoUrl) {
            return null;
        }
        let formattedLink = getFormattedYoutubeLink(S.hotelDetails.videoUrl);
        if (!formattedLink) {
            return null;
        }
        return (
            <div
                className={classes.videoContainer}
            >
                <iframe
                    className={classes.videoEmbed}
                    src={formattedLink}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen={true}
                />
            </div>
        );

    }
}
